// src/data/phraseProgressStorage.js
import { supabase } from "../supabaseClient";

const TABLE = "phrase_progress";

/**
 * Lädt den correct_count für (user, profile, language, pace).
 * Mit weekIndex: nur diese Woche (jede Woche zählt für sich, kein Vorarbeiten).
 * Ohne weekIndex: Summe über alle Wochen (bisheriges Verhalten, für ältere Aufrufer).
 * Gibt 0 zurück, wenn noch kein Eintrag existiert.
 */
export async function loadPhraseProgress(
  userId,
  profileId,
  languageId,
  pace,
  weekIndex
) {
  if (!userId) return 0;

  let query = supabase
    .from(TABLE)
    .select("correct_count")
    .eq("user_id", userId)
    .eq("profile_id", profileId)
    .eq("language_id", languageId)
    .eq("pace", pace);
  if (weekIndex) query = query.eq("week_index", weekIndex);

  const { data, error } = await query;

  if (error) {
    console.warn("loadPhraseProgress error:", error);
    return 0;
  }

  return (data || []).reduce(
    (sum, row) =>
      sum + (typeof row.correct_count === "number" ? row.correct_count : 0),
    0
  );
}

/**
 * Schreibt den correct_count einer Woche (Upsert).
 */
export async function savePhraseProgress(
  userId,
  profileId,
  languageId,
  pace,
  correctCount,
  weekIndex = 1
) {
  if (!userId) return;

  const payload = {
    user_id: userId,
    profile_id: profileId,
    language_id: languageId,
    pace,
    week_index: weekIndex,
    correct_count: correctCount,
  };

  const { error } = await supabase.from(TABLE).upsert(payload, {
    onConflict: "user_id,profile_id,language_id,pace,week_index",
  });

  if (error) {
    console.warn("savePhraseProgress error:", error);
  }
}

/**
 * Setzt den correct_count für (user, profile, language, pace) in allen Wochen auf 0.
 */
export async function resetPhraseProgress(
  userId,
  profileId,
  languageId,
  pace
) {
  if (!userId) return;

  const { error } = await supabase
    .from(TABLE)
    .update({ correct_count: 0 })
    .eq("user_id", userId)
    .eq("profile_id", profileId)
    .eq("language_id", languageId)
    .eq("pace", pace);

  if (error) {
    console.warn("resetPhraseProgress error:", error);
  }
}
